/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  CAROUSEL_ROOT: "carousel", //main-wrapper
  CAROUSEL_COLOR_INTERACTIVE: "carousel-color-interactive", //main-wrapper
  CAROUSEL_COLOR_PRIMARY: "carousel-color-primary", //main-wrapper
  CAROUSEL_SLIDES_SECTION: "carousel-slides-section", //control-and-slide-wrapper
  CAROUSEL_SLIDES: "carousel-slides", //container-wrapper
  CAROUSEL_CONTENT_SECTION: "carousel-content-section", //container
  CAROUSEL_CONTENT_ROOT: "carousel-content-root", //content-wrapper
  CAROUSEL_CONTENT: "carousel-content", //content
  CAROUSEL_SLIDE: "carousel-slide", //slide-content-wrapper
  CAROUSEL_SLIDE_SELECTED: "carousel-slide-selected",

  CAROUSEL_HEART: "carousel-heart",

  CAROUSEL_ARROW_SECTION: "carousel-arrow-section",
  CAROUSEL_ARROW: "carousel-arrow", //carousel-arrow
  CAROUSEL_ARROW_LEFT: "carousel-arrow-left", //carousel-arrow-left
  CAROUSEL_ARROW_RIGHT: "carousel-arrow-right", //carousel-arrow-right

  CAROUSEL_DOTS: "carousel-dots", //control-dots
  CAROUSEL_DOT: "carousel-dot", //carousel-dot
  CAROUSEL_DOT_SELECTED: "carousel-dot-selected", //carousel-selected-dot

  CAROUSEL_BG_COLOR: "carousel-bg-color",
};
